import { render, staticRenderFns } from "./IgnoreBulkUpgrade.vue?vue&type=template&id=023621e0&scoped=true&"
import script from "./IgnoreBulkUpgrade.vue?vue&type=script&lang=js&"
export * from "./IgnoreBulkUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023621e0",
  null
  
)

export default component.exports